import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { IRuleProviderService } from 'casl-authorize';
import { CaslRuleRequest } from '../../model/casl-rule/casl-rule.request';

@Injectable({
  providedIn: 'root',
})
export class RuleProviderService implements IRuleProviderService {
  getRules() {
    const request = new CaslRuleRequest.List();
    return request.call().pipe(
      // filter((data) => !!data?.response?.data?.[0]),
      map((data) => {
        return data.response.data;
      }),
    );
  }
}
